import useChatActions from '@src/hooks/useChatActions';
import { AgentChatTransferStatus } from '@src/model/frontendmodel';
import { ChatTray } from '@src/types/chats';

const useChatPinned = (chat: ChatTray) => {
  const { pinChat } = useChatActions();

  const isDisabled = [
    AgentChatTransferStatus.REQUESTED,
    AgentChatTransferStatus.PICKED_UP,
  ].includes(chat?.chatXferRequest?.status as AgentChatTransferStatus);

  const hasPinnedIndicator = Boolean(chat?.pinId);

  const onToggleChatPinned = (chatId: ChatTray['id']) => pinChat(chatId);

  return {
    pinned: hasPinnedIndicator,
    togglePin: onToggleChatPinned,
    disabled: isDisabled,
  };
};

export default useChatPinned;
